import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ_KEYS = ['start', 'sync', 'reseller', 'rocketSaaS', 'access', 'support', 'api', 'permanentUs'] as const;

export function HomeFaq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<string | null>('start');

  const renderAnswer = (key: (typeof FAQ_KEYS)[number]) => {
    if (key === 'start') {
      return (
        <p className="whitespace-pre-wrap">
          {t('home.faq.items.start.a')}{' '}
          <Link to="/register">{t('home.hero.register')}</Link>
        </p>
      );
    }
    if (key === 'support') {
      return (
        <p className="whitespace-pre-wrap">
          {t('home.faq.items.support.a')}{' '}
          <Link to="/support">{t('staticPages.support.title')}</Link>
        </p>
      );
    }
    if (key === 'api') {
      return (
        <p className="whitespace-pre-wrap">
          {t('home.faq.items.api.a')}{' '}
          <a href="/api-docs.html" target="_blank" rel="noreferrer">
            {t('home.builders.exploreApi')}
          </a>
        </p>
      );
    }
    return <p className="whitespace-pre-wrap">{t(`home.faq.items.${key}.a`)}</p>;
  };

  return (
    <section className="dx-faq" id="faq">
      <div className="dx-section__intro">
        <h2>{t('home.faq.title')}</h2>
        <p className="lead">{t('home.faq.subtitle')}</p>
      </div>
      <div className="dx-faq__list">
        {FAQ_KEYS.map((key) => {
          const isOpen = open === key;
          return (
            <div key={key} className={`dx-faq__item ${isOpen ? 'is-open' : ''}`}>
              <button
                type="button"
                className="dx-faq__q"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? null : key)}
              >
                <span>{t(`home.faq.items.${key}.q`)}</span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              {isOpen && <div className="dx-faq__a">{renderAnswer(key)}</div>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
